module.exports = __webpack_public_path__ + "img/1119.cf2010f5.gif";